import { hasSupplementalUiCopy } from "@/config/locale";
type PackageSummaryFormatter = (values: { count: number; vials: number }) => string;

const BOX_SUFFIXES = [
	/Box\s+mit\s+([1-9]\d*)\s+Vials?(\s*)$/i,
	/Box\s*\(\s*([1-9]\d*)\s+Vials?\s*\)(\s*)$/i,
	/([1-9]\d*)-Vial-Box(\s*)$/i,
];

/** Localize recognized packaging for locales with authored supplemental display copy without changing the source variant. */
export function getVariantDisplayLabel(
	name: string,
	locale: string | undefined,
	formatSummary: PackageSummaryFormatter,
): string {
	if (!hasSupplementalUiCopy(locale)) return name;

	for (const pattern of BOX_SUFFIXES) {
		const match = name.match(pattern);
		if (!match || match.index === undefined) continue;
		// Reject partial quantities such as "2,5-Vial-Box" or identifier suffixes.
		if (match.index > 0 && !/[\s·|]/u.test(name[match.index - 1]!)) continue;
		const prefix = name.slice(0, match.index);
		if (
			/^\d/.test(match[0]) &&
			(/(?:^|[\s·|])\d[\d\s.,/+−-]*$/u.test(prefix) || /^\s*[+-]\s*$/u.test(prefix))
		)
			continue;
		const vials = Number(match[1]);
		if (!Number.isSafeInteger(vials) || vials < 1) return name;
		return `${prefix}${formatSummary({ count: 1, vials })}${match[2]}`;
	}
	return name;
}
